<template>
  <router-link
    v-if="data && data.name"
    :to="{ name: data.name, params: data.params, query: data.query }"
    class="mr-1 inline-flex rounded-sm"
    :class="classes"
    :title="data.title"
    :target="getTabStatus()"
    v-tooltip="helper.translate(tooltip)"
  >
    <button type="button" class="p-0.5">
      <component :is="icon" class="h-6 w-6 p-0.5 link" aria-hidden="true" />
    </button>
    <span>{{ data.text }}</span>
  </router-link>
  <a
    v-else
    :href="data.link"
    :target="getTabStatus()"
    @click="handlerClick"
    class="mr-1 inline-flex rounded-sm"
    :class="classes"
    v-tooltip="helper.translate(tooltip)"
  >
    <component
      :is="icon"
      class="h-6 w-6 m-0.5 p-0.5 no-link"
      aria-hidden="true"
    />
    <span>{{ data.text ?? "" }}</span>
  </a>
</template>

<style>
  .isDisabled  {
    cursor: not-allowed;
    opacity: 0.5;
    pointer-events: none;
  }

</style>
<script>
import {
  EyeIcon,
  PrinterIcon,
  HomeIcon,
  PencilAltIcon,
  CheckCircleIcon,
  TrashIcon,
  ShieldCheckIcon,
  ReplyIcon,
  CheckIcon,
  BanIcon,
  RefreshIcon,
  SearchIcon,
  TicketIcon,
  ChatAltIcon,
  BellIcon,
  ArchiveIcon,
  RewindIcon,
  ClipboardIcon,
  BackspaceIcon,
  QuestionMarkCircleIcon,
  CloudDownloadIcon,
  LocationMarkerIcon,
  TruckIcon,
  XCircleIcon,
  BadgeCheckIcon,
  InformationCircleIcon,
  DocumentDownloadIcon,
  ChevronDoubleRightIcon,
  ShareIcon,
  OfficeBuildingIcon,
 
} from "@heroicons/vue/outline";

import { LightBulbIcon, PlusCircleIcon } from "@heroicons/vue/solid";
import helper from "../../util/helper";

export default {
  name: "SmallButton",
  components: {
    EyeIcon,
    PrinterIcon,
    HomeIcon,
    PencilAltIcon,
    CheckCircleIcon,
    TrashIcon,
    ShieldCheckIcon,
    ReplyIcon,
    CheckIcon,
    BanIcon,
    RefreshIcon,
    SearchIcon,
    TicketIcon,
    ChatAltIcon,
    BellIcon,
    ArchiveIcon,
    RewindIcon,
    ClipboardIcon,
    BackspaceIcon,
    QuestionMarkCircleIcon,
    LightBulbIcon,
    CloudDownloadIcon,
    LocationMarkerIcon,
    TruckIcon,
    XCircleIcon,
    BadgeCheckIcon,
    InformationCircleIcon,
    DocumentDownloadIcon,
    ChevronDoubleRightIcon,
    ShareIcon,
    PlusCircleIcon,
    OfficeBuildingIcon
  },
  props: {
    data: {
      default: () => {},
      type: Object,
      required: true,
    },
    disabled: {
      default: false,
      type: Boolean,
      required: false,
    },
  },
  computed: {
    classes() {
      return `${this.data.cssClass} ${this.disabled ? "isDisabled" : ""}`;
    },
    icon() {
      return `${this.data.icon}`;
    },
    tooltip() {
      return `${this.data.tooltip ?? this.data.title}`;
    },
  },

  data() {
    return {
      helper,
    };
  },

  methods: {
    handlerClick(e) {
      if (this.data.prevent) {
        e.preventDefault();
      }
      if (this.data.callback) {
        this.data.callback(this.data);
      }
      if (this.data.event) {
        this.$emit(this.data.event, this.data);
      }
      if (this.data.delete) {
        this.$emit(this.data.delete, { isOpen: true, id: this.data.label.id });
      }
      this.$emit("click", this.data);
    },
    resolveCallback() {
      return this.data.excelInfo.callback(this.data.excelInfo.params);
    },
    getTabStatus() {
      return this.data.newTab ? "_blank" : "";
    },
  },
};
</script>